import React from "react";
import styled from "styled-components";
import numeral from "numeral";
import { Grid } from "@material-ui/core";
import { MaterialIcon } from "@loanbossinc/component-library";
import { isEmpty } from "lodash";

const StyledNoContactContaner = styled.div`&& {
  /* Fill / Gray */
  background: #FAFAFA;
  
  /* Stroke / Gray */
  border: 1px solid #DADCE0;
  box-sizing: border-box;
  border-radius: 8px;
  width: 528px;
  height: 156px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  font-family: Work Sans;
  font-style: normal;
}`;
const StyledContactContaner = styled.div`&& {
  /* Fill / Gray */
  background: #FAFAFA;
  
  /* Stroke / Gray */
  border: 1px solid #DADCE0;
  box-sizing: border-box;
  border-radius: 8px;
  width: 528px;
  height: 156px;
  display: flex;
  justify-content: flex-start
  flex-direction: column;

  font-family: Work Sans;
  font-style: normal;
}`;
const StyledNoContactText = styled.div`&& {
  /* Work Sans / 16 Regular */
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  margin-top: 41px;
  /* Fill / Dark Gray */
  color: #5F6368;
}`;
const StyledNoContactLink = styled.div`&& {
  /* Work Sans / 14 Medium */
  font-weight: 500;
  font-size: 14px;
  line-height: 130%;

  /* Fill / LB Blue */
  color: #005AA9;
  cursor: pointer;
}`;
const StyledContactItem = styled.div`&& {
  margin-top:30px;
}`;
const StyledContactIconConainer = styled.span`&&{
  margin-right: 23px;
  margin-left: 27px;
  color: #5F6368;
}`;
const StyledGridContainer = styled(Grid)`&&{
  margin-top: 26px
}`;


const getLenderContactInformation = lenderContact => {
  const emailMailTo = lenderContact.email ? `mailto:${lenderContact.email}` : "";

  return (
    <StyledGridContainer item xs={12}>
      <StyledContactContaner>
        {lenderContact.phone &&
          <StyledContactItem>
            <StyledContactIconConainer>
              <MaterialIcon iconName={"phone"} />
            </StyledContactIconConainer>
            {numeral(lenderContact.phone).format("(NNN) NNN-NNNN")}
          </StyledContactItem>}
        {lenderContact.email &&
          <StyledContactItem>
            <StyledContactIconConainer>
              <MaterialIcon iconName={"email"} />
            </StyledContactIconConainer>
            <a href={emailMailTo}>{lenderContact.email}</a>
          </StyledContactItem>}
        {!lenderContact.phone && !lenderContact.email &&
          <StyledNoContactContaner>
            <StyledNoContactText>No Contact information available for this contact</StyledNoContactText>
          </StyledNoContactContaner>}
      </StyledContactContaner>
    </StyledGridContainer>
  );
};

const getEmptyLenderContactInformation = handleOpenRequestContactModal => (
  <StyledGridContainer item xs={12}>
    <StyledNoContactContaner>
      <StyledNoContactText>Select a lender before choosing a contact to display their information here.</StyledNoContactText>
      <br />
      <StyledNoContactLink onClick={handleOpenRequestContactModal}>Can’t find your lender or contact?</StyledNoContactLink>
    </StyledNoContactContaner>
  </StyledGridContainer>
);

const LenderContactInformation = ({lenderContact, handleOpenRequestContactModal}) => {
  if (isEmpty(lenderContact)) {
    return getEmptyLenderContactInformation(handleOpenRequestContactModal);
  }

  return getLenderContactInformation(lenderContact);
};

export default LenderContactInformation;
